import React from "react";
import { Link } from "react-router-dom";

// Obaluje jméno klienta do odkazu na jeho profil v sekci Klienti.
// Použití: <ClientLink name="Jana Novak" /> → /clients?search=Jana+Novak&open=1
export default function ClientLink({ name, className = "", children }) {
  if (!name) return <span className={className}>{children || "—"}</span>;
  const encoded = encodeURIComponent(name);
  return (
    <Link
      to={`/clients?search=${encoded}&open=1`}
      className={`hover:underline cursor-pointer transition-colors ${className}`}
      title={`Otevřít profil: ${name}`}
      onClick={(e) => e.stopPropagation()}
    >
      {children || name}
    </Link>
  );
}
